import { useCustomSearchParams } from "./use-search-params"

const useParamsDialog = (dialogParam: string) => {
  /*--------------------hooks--------------------*/
  const [searchParams, setSearchParams] = useCustomSearchParams()
  /*--------------------config--------------------*/
  const isOpen = searchParams.get(dialogParam) === "true"
  /*--------------------helpers--------------------*/
  const open = () =>
    setSearchParams((p) => {
      p.set(dialogParam, "true")
      return p
    })

  //nel caso in cui abbiamo una modale sopra l'altra e dobbiamo chiuderle entrambe oppure dobbiamo fare cleanup vari
  const close = (extraParams?: any) =>
    setSearchParams((p) => {
      p.delete(dialogParam)
      if (extraParams && Array.isArray(extraParams))
        extraParams.forEach((param) => p.delete(param))
      return p
    })

  return [isOpen, { open, close }] as const
}

export { useParamsDialog }
